/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createDestinationItem } from "../graphql/mutations";
const client = generateClient();
export default function DestinationItemCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    destinationId: "",
    pointOfInterestId: "",
    carrierId: "",
    bucket: "",
    iataCode: "",
    title: "",
    summary: "",
    picture: "",
    isActive: false,
  };
  const [destinationId, setDestinationId] = React.useState(
    initialValues.destinationId
  );
  const [pointOfInterestId, setPointOfInterestId] = React.useState(
    initialValues.pointOfInterestId
  );
  const [carrierId, setCarrierId] = React.useState(initialValues.carrierId);
  const [bucket, setBucket] = React.useState(initialValues.bucket);
  const [iataCode, setIataCode] = React.useState(initialValues.iataCode);
  const [title, setTitle] = React.useState(initialValues.title);
  const [summary, setSummary] = React.useState(initialValues.summary);
  const [picture, setPicture] = React.useState(initialValues.picture);
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setDestinationId(initialValues.destinationId);
    setPointOfInterestId(initialValues.pointOfInterestId);
    setCarrierId(initialValues.carrierId);
    setBucket(initialValues.bucket);
    setIataCode(initialValues.iataCode);
    setTitle(initialValues.title);
    setSummary(initialValues.summary);
    setPicture(initialValues.picture);
    setIsActive(initialValues.isActive);
    setErrors({});
  };
  const validations = {
    destinationId: [],
    pointOfInterestId: [],
    carrierId: [],
    bucket: [],
    iataCode: [],
    title: [],
    summary: [],
    picture: [],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          destinationId,
          pointOfInterestId,
          carrierId,
          bucket,
          iataCode,
          title,
          summary,
          picture,
          isActive,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createDestinationItem.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "DestinationItemCreateForm")}
      {...rest}
    >
      <TextField
        label="Destination id"
        isRequired={false}
        isReadOnly={false}
        value={destinationId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId: value,
              pointOfInterestId,
              carrierId,
              bucket,
              iataCode,
              title,
              summary,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.destinationId ?? value;
          }
          if (errors.destinationId?.hasError) {
            runValidationTasks("destinationId", value);
          }
          setDestinationId(value);
        }}
        onBlur={() => runValidationTasks("destinationId", destinationId)}
        errorMessage={errors.destinationId?.errorMessage}
        hasError={errors.destinationId?.hasError}
        {...getOverrideProps(overrides, "destinationId")}
      ></TextField>
      <TextField
        label="Point of interest id"
        isRequired={false}
        isReadOnly={false}
        value={pointOfInterestId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId: value,
              carrierId,
              bucket,
              iataCode,
              title,
              summary,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.pointOfInterestId ?? value;
          }
          if (errors.pointOfInterestId?.hasError) {
            runValidationTasks("pointOfInterestId", value);
          }
          setPointOfInterestId(value);
        }}
        onBlur={() =>
          runValidationTasks("pointOfInterestId", pointOfInterestId)
        }
        errorMessage={errors.pointOfInterestId?.errorMessage}
        hasError={errors.pointOfInterestId?.hasError}
        {...getOverrideProps(overrides, "pointOfInterestId")}
      ></TextField>
      <TextField
        label="Carrier id"
        isRequired={false}
        isReadOnly={false}
        value={carrierId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId: value,
              bucket,
              iataCode,
              title,
              summary,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.carrierId ?? value;
          }
          if (errors.carrierId?.hasError) {
            runValidationTasks("carrierId", value);
          }
          setCarrierId(value);
        }}
        onBlur={() => runValidationTasks("carrierId", carrierId)}
        errorMessage={errors.carrierId?.errorMessage}
        hasError={errors.carrierId?.hasError}
        {...getOverrideProps(overrides, "carrierId")}
      ></TextField>
      <TextField
        label="Bucket"
        isRequired={false}
        isReadOnly={false}
        value={bucket}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId,
              bucket: value,
              iataCode,
              title,
              summary,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.bucket ?? value;
          }
          if (errors.bucket?.hasError) {
            runValidationTasks("bucket", value);
          }
          setBucket(value);
        }}
        onBlur={() => runValidationTasks("bucket", bucket)}
        errorMessage={errors.bucket?.errorMessage}
        hasError={errors.bucket?.hasError}
        {...getOverrideProps(overrides, "bucket")}
      ></TextField>
      <TextField
        label="Iata code"
        isRequired={false}
        isReadOnly={false}
        value={iataCode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId,
              bucket,
              iataCode: value,
              title,
              summary,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.iataCode ?? value;
          }
          if (errors.iataCode?.hasError) {
            runValidationTasks("iataCode", value);
          }
          setIataCode(value);
        }}
        onBlur={() => runValidationTasks("iataCode", iataCode)}
        errorMessage={errors.iataCode?.errorMessage}
        hasError={errors.iataCode?.hasError}
        {...getOverrideProps(overrides, "iataCode")}
      ></TextField>
      <TextField
        label="Title"
        isRequired={false}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId,
              bucket,
              iataCode,
              title: value,
              summary,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <TextField
        label="Summary"
        isRequired={false}
        isReadOnly={false}
        value={summary}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId,
              bucket,
              iataCode,
              title,
              summary: value,
              picture,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.summary ?? value;
          }
          if (errors.summary?.hasError) {
            runValidationTasks("summary", value);
          }
          setSummary(value);
        }}
        onBlur={() => runValidationTasks("summary", summary)}
        errorMessage={errors.summary?.errorMessage}
        hasError={errors.summary?.hasError}
        {...getOverrideProps(overrides, "summary")}
      ></TextField>
      <TextField
        label="Picture"
        isRequired={false}
        isReadOnly={false}
        value={picture}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId,
              bucket,
              iataCode,
              title,
              summary,
              picture: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.picture ?? value;
          }
          if (errors.picture?.hasError) {
            runValidationTasks("picture", value);
          }
          setPicture(value);
        }}
        onBlur={() => runValidationTasks("picture", picture)}
        errorMessage={errors.picture?.errorMessage}
        hasError={errors.picture?.hasError}
        {...getOverrideProps(overrides, "picture")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              destinationId,
              pointOfInterestId,
              carrierId,
              bucket,
              iataCode,
              title,
              summary,
              picture,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
